export default {

    title: 'Aveco de Bondt Loggerdatabase',
    homeRoute: 'loggers',
    language: 'nl',
    defaultActionDeadline: 28,

    mapShapefileUrl: '/lagen-wls.geojson'
}
